<template>
    <div class="opui-item op-flow-type-trigger">
        <div class="opui-left">
            <a href="#" class="op-flow-icon">
                <span v-html="trigger.icon"></span>
            </a>
            <div class="opui-title">
                <p><a href="#">{{ $e('Trigger event: When this happens') }}</a></p>
                <h3><a href="#">{{ trigger.title }}</a></h3>
            </div>
        </div>
        <div class="op-flow-actions">
            <a href="#" class="op-flow-action">
                <i class="opui-fa opui-fa-cog"></i>
                {{ $e('Edit') }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        trigger:  { type: Object, required: true },
        workflow: { type: Object, required: true },
    },
}
</script>
